import {
    SEARCH_PRODUCTS_PENDING,
    SEARCH_PRODUCTS_FULFILLED,
    SEARCH_PRODUCTS_REJECTED,
    FETCH_PRODUCT_DETAIL_FULFILLED,
    TAGGING_PRODUCTS_FULFILLED,
} from '../actions/ProductsCreators';
import { RENEME_PRODUCT_FULFILLED } from '../actions/ProductDetailCreators';
import _ from 'lodash';

export function productReducer(state = {
    isLoading: false,
    products: {},
    hasMore: true,
    total: 0,
    timeOut: false,
    cursor: 0,
    showFullCategories: false
}, action) {

    switch (action.type) {
        // ************************** Search *************************** //
        case SEARCH_PRODUCTS_PENDING:
            return {
                ...state,
                isLoading: true
            };
        case SEARCH_PRODUCTS_REJECTED:
            return {
                ...state,
                isLoading: false
            };
        case SEARCH_PRODUCTS_FULFILLED:
            const { products, hasMore, total, timeOut, cursor } = action.payload.data;
            return {
                ...state,
                isLoading: false,
                products: _.mapKeys(products, 'id'),
                hasMore,
                timeOut,
                cursor,
                total
            };
        case FETCH_PRODUCT_DETAIL_FULFILLED:
        case RENEME_PRODUCT_FULFILLED:
            const newProduct = action.payload;
            return {
                ...state,
                isLoading: false,
                products: {
                    ...state.products,
                    [newProduct.id]: newProduct
                }
            };
        // ************************** Tagging *************************** //
        case TAGGING_PRODUCTS_FULFILLED:
            const product = action.payload;
            const oldProd = state.products[product.id];
            if (!oldProd) {
                return {
                    ...state
                }
            }
            oldProd.tags = product.tags;
            return {
                ...state,
                isLoading: false,
                products: {
                    ...state.products,
                    [product.id]: oldProd
                }
            };
        default:
    }
    return state;
}
